import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    enfermedad: [],
  },

  getters: {
    getEnfermedad: (state) => state.enfermedad,

    getListaEnfermedades: (state) => {
      const listaEnfermedades = [];

      state.enfermedad.forEach((enfermedad) => {
        listaEnfermedades.push({
          fk_idCatEnfermedad: enfermedad.id,
          enfermedad: enfermedad.enfermedad,
          fechaInicio: null,
          fechaFin: null,
          tratamientoMedico: false,
          detalle: '',
        });
      });

      return listaEnfermedades;
    },
  },

  mutations: {
    SET_ENFERMEDAD(state, enfermedad) {
      state.enfermedad = enfermedad;
    },
  },

  actions: {
    async fetchEnfermedad({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catEnfermedad')
        .then((response) => {
          commit('SET_ENFERMEDAD', response.data.data);
        });
    },
  },
};
